<template>
  <page-header
    title-ch="企業專區"
    title-en="ENTERPRISE"
  />
</template>
<script>
import PageHeader from '~components/pages/Header'
export default {
  name: 'StudentLoginHeader',
  components: {
    PageHeader
  }
}
</script>
